import * as yup from "yup";
import { normalizeRentalIds, propertySelectionError } from "./propertyHelpers";

export const isTaskPropertyRequired = (showTaskType, taskType) =>
  showTaskType && taskType !== "other";

export const buildTaskFormSchema = (showTaskType, { multipleProperties = false, recurring = false } = {}) => yup.object().shape({
  summary: yup.string().required("Summary is required"),
  task_type: showTaskType
    ? yup.string().nullable().required("Task type is required")
    : yup.string().nullable(),
  manager_id: yup.string().nullable(),
  rental_id: yup.string().nullable().when("task_type", (taskType, schema) =>
    !multipleProperties && isTaskPropertyRequired(showTaskType, taskType)
      ? schema.required("Property is required")
      : schema
  ),
  rental_scope: yup.string().nullable(),
  rental_ids: yup.array().nullable().test("task-properties", "Select properties", function (value) {
    if (!multipleProperties) return true;
    const message = propertySelectionError({ ids: normalizeRentalIds(value),
      taskType: this.parent.task_type, recurring,
      allRentals: recurring && this.parent.rental_scope === "all_rentals" });
    return message ? this.createError({ message }) : true;
  }),
});
